import Vue from "vue"

const WindowEvent = new Vue()
const WindowEventTypes = {
    escape: "escape",
}

const EnvioEvent = new Vue()
const EnvioEventTypes = {
    verEnvio: "verEnvio",
}

const OrdenCompraEvent = new Vue()
const OrdenCompraEventTypes = {
    cargarItems: "cargarItems",
    generarTransferencia: "generarTransferencia",
    cargarItemsDePedido: "cargarItemsDePedido",
}

const InputSelectEvent = new Vue()
const InputSelectEventTypes = {
    close: "close",
}

export {
    WindowEvent,
    WindowEventTypes,
    EnvioEvent,
    EnvioEventTypes,
    OrdenCompraEvent,
    OrdenCompraEventTypes,
    InputSelectEvent,
    InputSelectEventTypes,
}